<div class="overlay-inner-wrapper">
  <header class="header-2 scroll-x">
    <div class="branding">
      <span class="title">
        {{ 'Vorlagen für Spezifikationen verwalten' | mrTranslate }}
      </span>
    </div>
    <div class="header-actions">
      <div class="header-nav">
        <a class="nav-link nav-icon close" (click)="close()">
          <cds-icon shape="times" size="22" [title]="'Schliessen' | mrTranslate" />
        </a>
      </div>
    </div>
  </header>
  <div class="w-100-p padding-10-lr padding-12-tb scroll-y h-60 d-f col">
    @if (isLoading()) {
      <clr-spinner class="centred" />
    } @else if (table().columns.length) {
      <div class="btn-group">
        <button type="button" class="btn btn-icon" (click)="openedCode.set(undefined); modal.open()">
          <clr-tooltip>
            <cds-icon clrTooltipTrigger shape="plus" />
            <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'lg'">
              {{ 'Neue Vorlage hinzufügen' | mrTranslate }}
            </clr-tooltip-content>
          </clr-tooltip>
        </button>
      </div>
      <clr-datagrid class="datagrid-compact fill-space" [clrDgItemsIdentityFn]="row => row?.id">
        @for (column of table().columns; track $index) {
          <clr-dg-column [clrDgField]="column.id" [title]="column.id">
            <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns: ['bild'] }">
              {{ column.id | titlecase }}
            </ng-container>
          </clr-dg-column>
        }
        <ng-template
          clrVirtualScroll
          let-row
          [clrVirtualRowsOf]="table().rows"
          [clrVirtualRowsTrackBy]="(_, row) => row?.ID">
          <clr-dg-row [clrDgItem]="row">
            @for (cell of table().columns; track $index) {
              <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
            }
          </clr-dg-row>
        </ng-template>
        <ng-template [clrIfDetail]="openedCode()" (clrIfDetailChange)="openedCode.set($event)">
          <clr-dg-detail>
            <clr-dg-detail-header>{{ openedCode()?.Code }}</clr-dg-detail-header>
            <clr-dg-detail-body>
              <ng-container *ngTemplateOutlet="form; context: { mode: 'edit' }" />
              <div class="clr-row nxm padding-6" style="max-width: 800px">
                <app-preview-thumbnails
                  class="clr-col-auto nxp"
                  #bild
                  [data]="openedBild()"
                  [showLabel]="true"
                  [title]="'Bild'"
                  [showCamera]="false"
                  [maxAmount]="1"
                  [acceptTypes]="'images/'"
                  [isSkizze]="true"
                  [skipSavedOnPack]="false" />
              </div>

              <div class="btn-group margin-48-t">
                <button type="submit" form="code-edit-form" class="btn btn-success" [clrLoading]="loadState()">
                  {{ 'Speichern' | mrTranslate }}
                </button>
                @if (!isRep) {
                  <button type="button" class="btn btn-danger" (click)="deleteCode()">
                    {{ 'Löschen' | mrTranslate }}
                  </button>
                }
                <button type="button" class="btn btn-outline" (click)="openedCode.set(undefined)">
                  {{ 'Abbrechen' | mrTranslate }}
                </button>
              </div>
            </clr-dg-detail-body>
          </clr-dg-detail>
        </ng-template>
        <clr-dg-footer>{{ table().rows.length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
      </clr-datagrid>
    }
  </div>
</div>

<clr-modal #modal [clrModalClosable]="true" [clrModalSize]="'lg'">
  <h3 class="modal-title">{{ 'neue Vorlage anlegen' | mrTranslate }}</h3>
  <div class="modal-body">
    <ng-container *ngTemplateOutlet="form; context: { mode: 'neu' }" />
    <div class="clr-row nxm padding-6" style="max-width: 800px">
      <app-preview-thumbnails
        class="clr-col-auto nxp"
        #bild
        [data]="openedBild()"
        [showLabel]="true"
        [title]="'Bild'"
        [showCamera]="false"
        [maxAmount]="1"
        [acceptTypes]="'images/'"
        [isSkizze]="true"
        [skipSavedOnPack]="false" />
    </div>
  </div>
  <div class="modal-footer">
    <div class="btn-group margin-10-t">
      <button type="submit" form="code-neu-form" class="btn btn-success" [clrLoading]="loadState()">
        {{ 'Speichern' | mrTranslate }}
      </button>
      <button type="button" class="btn btn-outline" (click)="modal.close()">
        {{ 'Abbrechen' | mrTranslate }}
      </button>
    </div>
  </div>
</clr-modal>

<ng-template #form let-mode="mode">
  <form
    id="code-{{ mode }}-form"
    clrForm
    autocomplete="off"
    class="width100 float-buttons"
    [clrLabelSize]="5"
    style="max-width: 800px"
    [formGroup]="codeForm"
    (ngSubmit)="codeForm.valid && saveCode(modal)">
    <clr-input-container>
      <label class="clr-required-mark">{{ 'Code' | mrTranslate }}</label>
      <input type="text" clrInput formControlName="Code" />
      <clr-control-error *clrIfError="'required'">
        {{ 'Erforderlich' | mrTranslate }}
      </clr-control-error>
      <clr-control-error *clrIfError="'in-Table'; error as message">
        {{ message | mrTranslate }}
      </clr-control-error>
    </clr-input-container>
    <clr-select-container>
      <label>
        @let scchf = 'Schienenform' | mrTranslate;
        <span class="clr-required-mark">{{ scchf }}</span>
        <div class="btn-group btn-sm btn-icon btn-float">
          <button
            class="btn"
            type="button"
            tabindex="-1"
            (click)="isBaseItemModalOpen.set(true); editTabelle.set({ tabelle: 'SSCHF', title: scchf })">
            <clr-tooltip>
              <cds-icon clrTooltipTrigger shape="note" />
              <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
                {{ 'Liste bearbeiten' | mrTranslate }}
              </clr-tooltip-content>
            </clr-tooltip>
          </button>
        </div>
      </label>
      <select clrSelect formControlName="Schienenform">
        @for (value of schienenformen(); track value) {
          <option [value]="value">{{ value }}</option>
        }
      </select>
      <clr-control-error *clrIfError="'required'">
        {{ 'Erforderlich' | mrTranslate }}
      </clr-control-error>
    </clr-select-container>
    <clr-select-container>
      <label>
        @let scchw = 'Schwellenart' | mrTranslate;
        <span [class.clr-required-mark]="!codeForm.value.Eindeckung">{{ scchw }}</span>
        <div class="btn-group btn-sm btn-icon btn-float">
          <button
            class="btn"
            type="button"
            tabindex="-1"
            (click)="isBaseItemModalOpen.set(true); editTabelle.set({ tabelle: 'SSCHW', title: scchw })">
            <clr-tooltip>
              <cds-icon clrTooltipTrigger shape="note" />
              <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
                {{ 'Liste bearbeiten' | mrTranslate }}
              </clr-tooltip-content>
            </clr-tooltip>
          </button>
        </div>
      </label>
      <select clrSelect formControlName="Schwellenart">
        @for (value of schwellenarten(); track value) {
          <option [value]="value">{{ value }}</option>
        }
      </select>
      <clr-control-error *clrIfError="'required'">
        {{ 'Erforderlich' | mrTranslate }}
      </clr-control-error>
    </clr-select-container>
    <clr-select-container>
      <label>
        @let sbeft = 'Schienenbefestigung' | mrTranslate;
        <span [class.clr-required-mark]="!codeForm.value.Eindeckung">{{ sbeft }}</span>
        <div class="btn-group btn-sm btn-icon btn-float">
          <button
            class="btn"
            type="button"
            tabindex="-1"
            (click)="isBaseItemModalOpen.set(true); editTabelle.set({ tabelle: 'SBEFT', title: sbeft })">
            <clr-tooltip>
              <cds-icon clrTooltipTrigger shape="note" />
              <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
                {{ 'Liste bearbeiten' | mrTranslate }}
              </clr-tooltip-content>
            </clr-tooltip>
          </button>
        </div>
      </label>
      <select clrSelect formControlName="Schienenbefestigung">
        @for (value of schienenbefestigungen(); track value) {
          <option [value]="value">{{ value }}</option>
        }
      </select>
      <clr-control-error *clrIfError="'required'">
        {{ 'Erforderlich' | mrTranslate }}
      </clr-control-error>
    </clr-select-container>
    <clr-select-container>
      <label>
        @let seind = 'Eindeckung' | mrTranslate;
        <span>{{ seind }}</span>
        <div class="btn-group btn-sm btn-icon btn-float">
          <button
            class="btn"
            type="button"
            tabindex="-1"
            (click)="isBaseItemModalOpen.set(true); editTabelle.set({ tabelle: 'SEIND', title: seind })">
            <clr-tooltip>
              <cds-icon clrTooltipTrigger shape="note" />
              <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
                {{ 'Liste bearbeiten' | mrTranslate }}
              </clr-tooltip-content>
            </clr-tooltip>
          </button>
        </div>
      </label>
      <select clrSelect formControlName="Eindeckung">
        @for (value of eindeckungen(); track value) {
          <option [value]="value">{{ value }}</option>
        }
      </select>
      <clr-control-error *clrIfError="'required'">
        {{ 'Erforderlich' | mrTranslate }}
      </clr-control-error>
    </clr-select-container>
    <clr-checkbox-container>
      <clr-checkbox-wrapper>
        <label>{{ 'Geschlossen' | mrTranslate }}</label>
        <input type="checkbox" clrToggle formControlName="Geschlossen" />
      </clr-checkbox-wrapper>
    </clr-checkbox-container>
    <clr-number-input-container>
      <label>{{ 'Preis pro m' | mrTranslate }}</label>
      <input type="number" clrNumberInput formControlName="Kosten" />
    </clr-number-input-container>
  </form>
</ng-template>

<app-baseitems-wrapper
  [(isModalOpen)]="isBaseItemModalOpen"
  [route]="editTabelle()"
  (refreshList)="updateTabelle($event)" />
